import { useState } from 'react';

import {
	RideButton as RideButtonBase,
	RideIcEmergencyLight as RideIcEmergencyLightBase,
	RideModalActions as RideModalActionsBase,
	RideModal as RideModalBase,
	RideModalContent as RideModalContentBase,
	RideTextArea as RideTextAreaBase,
} from '@rimac-seguros/ride-system-components';

const RideModal = RideModalBase as any;
const RideButton = RideButtonBase as any;
const RideModalContent = RideModalContentBase as any;
const RideModalActions = RideModalActionsBase as any;
const RideIcEmergencyLight = RideIcEmergencyLightBase as any;
const RideTextArea = RideTextAreaBase as any;

type ModalConfirmarCambiosProps = {
	isOpen?: boolean;
	onOpenChange?: (open: boolean) => void;
	onCloseButtonClick?: () => void;
	hookForm?: any;
	handleGuardar?: (...args: unknown[]) => void;
	setShowModal?: (show: boolean) => void;
	isRechazo?: boolean;
	isCancelar?: boolean;
};

export const ModalConfirmarCambios = ({
	isOpen,
	onOpenChange,
	onCloseButtonClick,
	hookForm,
	handleGuardar,
	setShowModal,
	isRechazo,
	isCancelar,
}) => {
	const [comentario, setComentario] = useState('');
	const [comentarioError, setComentarioError] = useState('');

	const validarComentario = () => {
		const value = comentario.trim();
		if (!value)
			return 'Debes ingresar un comentario para rechazar la solicitud.';
		if (value.length < 10)
			return 'El comentario debe tener al menos 10 caracteres.';
		if (value.length > 100)
			return 'El comentario no puede superar los 100 caracteres.';
		if (!/^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\s.,;:¡!¿?()\-[\]{}"'/\\]+$/.test(value)) {
			return 'Solo letras, números, espacios, tildes y signos de puntuación.';
		}
		return '';
	};

	const handleContinuar = () => {
		if (isRechazo || isCancelar) {
			const error = validarComentario();
			if (error) {
				setComentarioError(error);
				return;
			}
		}
		setComentarioError('');
		handleGuardar(isRechazo || isCancelar ? comentario : undefined);
	};

	return (
		<RideModal
			isOpen={isOpen}
			size="small"
			onOpenChange={onOpenChange}
			onCloseButtonClick={onCloseButtonClick}
		>
			<RideModalContent>
				<RideIcEmergencyLight
					size="x-large"
					className="modal__icon"
					style={{ display: 'flex', justifyContent: 'center' }}
				/>
				<h2
					style={{
						marginBottom: '20px',
						display: 'flex',
						justifyContent: 'center',
						marginTop: '20px',
						textAlign: 'center',
					}}
				>
					{isCancelar
						? '¿Está seguro de que quiere guardar esta cancelación?'
						: isRechazo
							? '¿Está seguro de que quiere rechazar la solicitud?'
							: '¿Está seguro de que quiere guardar los cambios?'}
				</h2>
				{(isRechazo || isCancelar) && (
					<div style={{ marginBottom: '16px', textAlign: 'center' }}>
						<RideTextArea
							label="Comentario: "
							value={comentario}
							onChange={(e) => {
								setComentario(e.target.value);
								if (comentarioError) setComentarioError('');
							}}
							error={!!comentarioError}
							errorMessage={comentarioError}
							placeholder="Comentario"
							size="medium"
							rows={2}
							required
						/>
					</div>
				)}
				<div style={{ marginBottom: '25px' }}></div>
			</RideModalContent>
			<RideModalActions
				primary={
					<RideButton
						text="Continuar"
						size="large"
						type={isRechazo || isCancelar ? 'button' : 'submit'}
						form={isRechazo || isCancelar ? undefined : 'ride-modal-form'}
						onClick={handleContinuar}
					/>
				}
				secondary={
					<RideButton
						text="Cancelar"
						variant="text-primary"
						size="large"
						onClick={() => setShowModal(false)}
					/>
				}
			/>
		</RideModal>
	);
};
